import { Button, Flex } from "antd";
import { PencilEdit02Icon, UploadIcon } from '@/icons';
import useModal from "../../../../../../hooks/useModal";
// import FileIcon from "../../_icons/FileIcon";
import EditCalendar from "./EditCalendar";
import UploadCalendar from "./UploadCalendar";

export default function LeaveSummeryEvents() {
  const { open, handleOpen, handleClose } = useModal<undefined, "EDIT">();
  const {
    open: uploadOpen,
    handleOpen: handleUploadOpen,
    handleClose: handleUploadClose,
  } = useModal<undefined, "UPLOAD">();
  return (
    <>
      <Flex className="mt-3" justify="end" gap={12}>
        <Button
          size="large"
          type="default"
          className="btn-primary-bordered"
          onClick={() => handleOpen({ type: "EDIT" })}
        >
          <PencilEdit02Icon size={20} /> Edit Calendar
        </Button>

        {/* <Button
          disabled
          size="large"
          className="btn-primary !font-bold !text-neutral-700 !text-base disabled:hover:!text-neutral-700 disabled:hover:opacity-80"
        >
          Generate Report
          <FileIcon className="text-base !font-semibold" />
        </Button> */}

        <Button
          size="large"
          className="btn-primary hover:!bg-teal-500 !text-neutral-700 hover:!text-neutral-700 !text-base !font-bold"
          onClick={() => handleUploadOpen({ type: "UPLOAD" })}
        >
          Upload Calendar
          <UploadIcon size={16} className="!font-semibold" />
        </Button>
      </Flex>

      {/* Edit Calendar Drawer */}
      <EditCalendar
        data={open.data}
        type={open.type}
        handleClose={handleClose}
        open={open.open && open.type === "EDIT"}
      />

      {/* Upload Calendar Drawer */}
      <UploadCalendar
        data={uploadOpen.data}
        type={uploadOpen.type}
        handleClose={handleUploadClose}
        open={uploadOpen.open && uploadOpen.type === "UPLOAD"}
      />
    </>
  );
}
